module.exports = __webpack_public_path__ + "static/media/tie-rods-red.090f2d49.svg";